import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
import Payment from '@/components/payment/payment.vue';
import ProjectService from '../../project.service';
export default {
  components: {
    Pagination,
    Payment
  },
  mixins: [],
  data() {
    return {
      currentProjectId: '',
      bidModeArr: [], // 竞价方式集合
      bidStatusArr: [
        {code: '', value: '全部'},
        {code: '1', value: '竞价中'},
        {code: '2', value: '未开始'},
        {code: '3', value: '已结束'}
      ], // 竞价状态
      total: 0,
      tableList: [],
      date: [],
      statusList: [],
      status: '', // 报名状态 // 需要传给后台的状态集合
      searchForm: {
        bidName: '',
        pageNum: 1,
        pageSize: 5,
        bidMode: '', // 竞价方式
        projectType: 1
      },
      showPayment: false,
      actionId: ''
    };
  },
  created() {
    const arr = [
      ['bidModeArr', 'BIDDING_METHOD']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      // 获取竞价方式和竞价状态的枚举
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = [{code: '', value: '全部'}, ...res.data];
        }
        this.getSignUpProjectList();
      });
    });
  },
  computed: {
  },
  methods: {
    changeSkin,
    indexMethod(index) {
      return (Number(this.searchForm.pageNum) - 1) * Number(this.searchForm.pageSize) + index + 1;
    },
    // 竞价状态切换获取code
    changeFormValue(status) {
      this.searchForm.status = status;
    },
    // 获取我的报名采购标的列表
    getSignUpProjectList(page){
      if (page && page.pageNo && page.pageSize) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = this.searchForm.pageNum;
        this.searchForm.pageSize = this.searchForm.pageSize;
      }
      const obj = {};
      Object.keys(this.searchForm).forEach((key) => {
        if(this.searchForm[key]){
          obj[key] = this.searchForm[key];
        }
      });
      ProjectService.selectBidList(obj).then(res => {
        if (res && res.code === '0' && res.data) {
          this.total = res.data.total;
          this.tableList = res.data.list;
          this.tableList.forEach(item => {
            if(item.status > 60) {
              item.status = 3; // 已结束 从字段查找中文
            }
            if(item.status === 60) {
              item.status = 1; // 竞价中
            }
            if(item.status === 50 || item.status === '') {
              item.status = 2; // 未开始
            }
          });
        } else {
          this.tableList = [];
          this.total = 0;
        }
      });
    },
    onChangeDate (event) {
      this.searchForm.startTime = event && event[0];
      this.searchForm.endTime = event && event[1];
    },
    clear () {
      this.searchForm = {
        bidName: '', // 标的名称
        pageNum: 1,
        pageSize: 5,
        bidMode: ''
      };
      this.status = '', // 报名状态
      this.date = [];
      this.getSignUpProjectList();
    },
    goToSignUpDetail (obj) {
      ProjectService.getEjyToken(obj.id).then(res => {
        if (res && res.code === '0' && res.data) {
          window.open(res.data);
        }
      });
    }
  }
};
